import * as React from "react";
import { FvcSession } from "webportalclient";
import { DynamicResultsGroupHeading } from "../../Shared/ResultsGroupHeading";
import { NextGenFixedCommentSelectors } from "./NextGenFixedCommentSelectors";
import { NextGenFixedCommentsState, ToggleSessionFixedCommentsVisibilityAction, ToggleTestFixedCommentsVisibilityAction, ToggleSessionFixedCommentCheckedAction, ToggleTestFixedCommentCheckedAction } from "./UseNextGenFixedComments";
import { ErrorBoundary } from "../../../errors/ErrorBoundary";

interface SiteResultsCommentsProps {
    session: FvcSession;
    updatedSession?: FvcSession;
    fixedCommentsState: NextGenFixedCommentsState;
    fixedCommentsDispatch;
    acceptabilityChangesAllowed: boolean;
}

export const SiteResultsComments = ({ session, updatedSession, fixedCommentsState, fixedCommentsDispatch, acceptabilityChangesAllowed }: SiteResultsCommentsProps) => {
    return (
        <ErrorBoundary>
            <DynamicResultsGroupHeading resultsCount={session.tests.length} title="Comments" />
            <NextGenFixedCommentSelectors
                headerPrefix="Technician"
                editable={acceptabilityChangesAllowed}
                sessionFixedComments={fixedCommentsState.sessionFixedComments}
                testFixedComments={fixedCommentsState.testFixedComments}
                onSessionFixedCommentClick={() => fixedCommentsDispatch(ToggleSessionFixedCommentsVisibilityAction.create())}
                onTestFixedCommentClick={testId => fixedCommentsDispatch(ToggleTestFixedCommentsVisibilityAction.create(testId))}
                session={session}
                updatedSession={updatedSession}
                handleSessionChange={(commentId, checked) => fixedCommentsDispatch(ToggleSessionFixedCommentCheckedAction.create(commentId, checked))}
                handleTestChange={(testId, commentId, checked) => fixedCommentsDispatch(ToggleTestFixedCommentCheckedAction.create(testId, commentId, checked))}
                handleSessionClose={() => fixedCommentsDispatch(ToggleSessionFixedCommentsVisibilityAction.create())}
                handleTestClose={(testId) => fixedCommentsDispatch(ToggleTestFixedCommentsVisibilityAction.create(testId))}
            />
        </ErrorBoundary>
    );
}
